import { useParams, Link } from 'react-router-dom';
import { getMoviesByCategory, categories } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryMovies = getMoviesByCategory(slug || '');
  const categoryName = category?.name || '分类';

  return (
    <>
      <SEOHead
        title={`${categoryName} - 星空电影网高清免费在线观看`}
        description={`星空电影网${categoryName}专区，精选${categoryMovies.length}部${categoryName}高清影片，免费在线观看。每日更新最新${categoryName}，畅享高清观影体验。`}
        keywords={`${categoryName},星空电影网,${categoryName}在线观看,${categoryName}高清,免费${categoryName}`}
        canonicalUrl={`https://www.xingkongmovie.com/category/${slug}`}
      />

      <main className="pt-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: categoryName },
            ]}
          />

          <div className="py-6">
            <div className="flex items-center gap-4 mb-6">
              {category && (
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className={`${category.icon} text-2xl text-primary-400`}></i>
                </div>
              )}
              <div>
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
                  {categoryName}
                </h1>
                <p className="text-sm text-foreground-500 mt-1">
                  共 {categoryMovies.length} 部影片
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-950'
                      : 'bg-background-100 text-foreground-400 hover:text-foreground-200 hover:bg-background-200/70 border border-background-200/50'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryMovies.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                {categoryMovies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <i className="ri-movie-line text-5xl text-foreground-600 mb-4 block"></i>
                <p className="text-foreground-500 text-lg">该分类暂无影片</p>
                <Link
                  to="/"
                  className="inline-flex items-center gap-1 mt-4 text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line"></i>
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
}